import React, { ReactNode } from 'react';

export type WealthNetWorthCardProps = {
  /** Omit to show only the range picker (when a KPI strip shows net worth). */
  netWorth?: ReactNode;
  delta?: ReactNode;
  breakdown?: ReactNode;
  timeRange?: ReactNode;
  notices?: ReactNode;
  tabs: ReactNode;
  chart: ReactNode;
  contentClassName?: string;
};

const WealthNetWorthCard: React.FC<WealthNetWorthCardProps> = ({
  netWorth,
  delta,
  breakdown,
  timeRange,
  notices,
  tabs,
  chart,
  contentClassName,
}) => (
  <div className="right-section">
    <div className={`net-worth-summary${netWorth === undefined ? ' is-range-only' : ''}`}>
      {netWorth !== undefined ? (
        <div className="summary-left">
          <div className="summary-title">Current Net Worth</div>
          <div className="summary-value">
            {netWorth}
            {delta}
          </div>
          {breakdown ? <div className="net-worth-breakdown">{breakdown}</div> : null}
        </div>
      ) : null}
      {timeRange}
    </div>
    {notices}
    <div className="main-tabs-section">
      <div className="main-tabs-header">{tabs}</div>
      <div className={`main-tabs-content${contentClassName ? ` ${contentClassName}` : ''}`}>
        {chart}
      </div>
    </div>
  </div>
);

export default WealthNetWorthCard;
